document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('#MobileMenu');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
      mobileMenu.classList.toggle('is-open', !open);
    });
    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menuButton.setAttribute('aria-expanded', 'false');
        mobileMenu.hidden = true;
        mobileMenu.classList.remove('is-open');
      });
    });
  }

  const finderButtons = document.querySelectorAll('.finder-options button');
  const methodTarget = document.querySelector('[data-finder-method]');
  const copyTarget = document.querySelector('[data-finder-copy]');
  finderButtons.forEach((button) => {
    button.addEventListener('click', () => {
      finderButtons.forEach((item) => {
        item.classList.remove('selected');
        item.setAttribute('aria-checked', 'false');
      });
      button.classList.add('selected');
      button.setAttribute('aria-checked', 'true');
      if (methodTarget) methodTarget.textContent = button.dataset.method || '';
      if (copyTarget) copyTarget.textContent = button.dataset.copy || '';
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-to-cart]');
    if (!select || !price || !button) return;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      price.textContent = option.dataset.price || '';
      button.disabled = !available;
      const label = button.querySelector('span');
      if (label) label.textContent = available ? 'Add to bag' : 'Sold out';
    });
  });
});
